import { log } from './utils'

function iFrameSendMessage(message, target) {
  if (isIframe()) {
    target = target || '*'
    log('iframe send: ', message)
    window.parent.postMessage(message, target)
  }
}

function iFrameAnnounceHeight(el, grow) {
  grow = grow || 0
  let body = document.body,
    html = document.documentElement,
    h = 0

  if (!el) {
    h =
      Math.max(
        body.scrollHeight ? body.scrollHeight : 0,
        body.offsetHeight ? body.offsetHeight : 0,
        html.clientHeight ? html.clientHeight : 0,
        html.offsetHeight ? html.offsetHeight : 0
      ) + grow
  } else {
    h = el.scrollHeight + grow
  }

  iFrameSendMessage({ height: h })
}

function isIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export { iFrameSendMessage, iFrameAnnounceHeight, isIframe }
